import React from 'react'
import { useTheme } from '@mui/material'
import { FilterProvider } from 'components/Filter/context'
import FooterWrapper from 'redesign/components/atoms/footer-wrapper'
import { ContentWrapper, HeaderContainer, Container } from './styles'
import type { DrawerHeaderWrapperProps } from './types'

const DrawerHeaderWrapper: React.FC<DrawerHeaderWrapperProps> = ({
  header,
  children,
  footer,
  backgroundColor,
  isLoading,
  configuration,
  providerName,
  dataTestId = 'side-menu__container',
}) => {
  const { palette } = useTheme()

  const Content = (
    <Container data-testid={dataTestId} backgroundColor={backgroundColor ?? palette.background.default}>
      <HeaderContainer>{header}</HeaderContainer>
      <ContentWrapper>{children}</ContentWrapper>
      {footer && <FooterWrapper>{footer} </FooterWrapper>}
    </Container>
  )

  if (isLoading || !configuration) return Content

  return (
    <FilterProvider configuration={configuration} name={providerName}>
      {Content}
    </FilterProvider>
  )
}

export default DrawerHeaderWrapper
